export const globalStyles = {
  colors: {
    brand: {
      primary: {
        DEFAULT: "#83C441",
        50: "#DEF0CD",
        100: "#D4EBBE",
        200: "#C0E19E",
        300: "#ACD77F",
        400: "#97CE60",
        500: "#83C441",
        600: "#679C31",
        700: "#4B7223",
        800: "#2F4716",
        900: "#121C09",
      },
      secondary: {
        DEFAULT: "#424242",
        50: "#9E9E9E",
        100: "#949494",
        200: "#7F7F7F",
        300: "#6B6B6B",
        400: "#565656",
        500: "#424242",
        600: "#262626",
        700: "#0A0A0A",
        800: "#000000",
        900: "#000000",
      },
    },
    gray: {
      DEFAULT: "#E8E8E8",
      50: "#FFFFFF",
      100: "#F4F4F4",
      200: "#E8E8E8",
      300: "#CCCCCC",
      400: "#B0B0B0",
      500: "#949494",
      600: "#787878",
      700: "#5C5C5C",
      800: "#404040",
      900: "#242424",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        margin: 0,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        textAlign: "left",
        color: "#333",
        overflowX: "hidden",
        bg: props.colorMode === "light" ? "#e8e8e8" : "#1F1F1F",
        letterSpacing: "-0.5px",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
